// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3e32b","signatureButtonsRight":"ModalSign_signatureButtonsRight__1YDXh"};